var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 52.917 52.917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.97538 0 0 .90442 -4.7534 -2.4837)",
    fill: "#444",
    strokeWidth: 0.2817
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.736 13.636-4.368-4.362c-0.451-0.451-1.044-0.677-1.636-0.677s-1.184 0.225-1.635 0.676l-3.494 3.484 7.639 7.626 3.494-3.483c0.903-0.902 0.903-2.365 0-3.264z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.607 22.017 42.967 14.39 21.922 35.396 29.562 43.023"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.642 46.28 27.913 44.654 20.273 37.028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.393 50.403h-28.806v-28.806h20.329l5.01-5h-27.106c-1.779 0-3.234 1.455-3.234 3.234v32.339c0 1.779 1.455 3.234 3.234 3.234h32.339c1.779 0 3.234-1.455 3.234-3.234v-23.121l-5 4.991z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9a768ef085ffa6ab36a097493f9f1622.svg";
export { ForwardRef as ReactComponent };